const convertStringToADF = (value: string) => ({
	type: 'doc',
	version: 1,
	content: [
		{
			type: 'paragraph',
			content: [
				{
					type: 'text',
					text: value,
				},
			],
		},
	],
});

export const getRichTextFieldValue = (defaultValue: unknown) => {
	if (Array.isArray(defaultValue) && defaultValue.length > 0) {
		if (typeof defaultValue[0] === 'string' || typeof defaultValue[0] === 'number')
			return convertStringToADF(defaultValue[0].toString());
	}
	if (typeof defaultValue === 'string' || typeof defaultValue === 'number') {
		// for connect we expect a simple string to be passed
		return convertStringToADF(defaultValue.toString());
	}
	return null;
};
